module.exports = __webpack_public_path__ + "img/avatar1.e25e1b6d.png";